import React, { useRef } from "react";


const BusinessOpportunity = () => {

  const scrollDown = () => {
    window.scrollBy({ top: 500, left: 0, behavior: "smooth" });
  };
  return (
    <div className="bg-gray-50 pt-36 pb-20" data-aos="fade-down">
      <div className="bg-gray-50 px-6 md:px-16">
        <div className="xl:max-w-6xl mx-auto flex flex-col-reverse md:flex-row items-center gap-8">
          {/* Text Section */}
          <div className="w-full md:w-1/2 text-center md:text-left">
            {/* <h2 className="text-lg">
              START GETTING NEW BUSINESS OPPORTUNITIES
            </h2> */}
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mt-4 leading-tight">
              Empowering Vendor Partners,
            </h1>
            <span className="text-3xl md:text-4xl font-bold text-gray-800 mt-4 leading-tight">
              Enabling Success
            </span>
            <p className="text-gray-400 mt-4 text-base md:text-lg leading-relaxed">
              Our cutting-edge platform is designed for the vendor partners and
              service providers who are the backbone of the Pixell ecosystem. We
              bring solid business at your doorstep, so that you don't have to
              worry about nurturing the leads.
            </p>

            <button onClick={scrollDown} className="mt-6 bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg shadow-lg">
              Know More →
            </button>
          </div>

          {/* Image Section */}
          <div className="w-full md:w-1/2 flex justify-center md:justify-end items-center relative">
            <img
              src="/assests/images/LandingPage/vendor/business-opp.webp"
              alt="Business"
              className="w-60 md:w-96  rounded-lg transform translate-x-4 translate-y-8"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessOpportunity;
